import { Modal } from "@risalabs_frontend_org/oasis-ui-kit";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  AuthLetterSuccessModalMetaData,
  AuthorizationCardInfoProps,
} from "../../../data-model/authLetterSuccessModel";
import { ModalId } from "../../../enums/modalId";
import { RootState } from "../../../redux/store/store";
import AuthorizationCardInfo from "./components/authorizationCardInfo";

/** Props for the Auth Letter Success modal. */
interface AuthLetterSuccessModalProps {
  /**
   * Invoked when the dialog is dismissed so the parent can clear the
   * Redux `openedModalId`, allowing the modal to be reopened later.
   */
  onClose: () => void;
}

/**
 * Read-only modal showing the authorization details for an order whose
 * Candid writeback has already succeeded. Authorizations are sourced
 * from `state.modal.metaData`.
 *
 * @param props.onClose - Called on dismiss to sync Redux modal state.
 */
const AuthLetterSuccessModal = ({ onClose }: AuthLetterSuccessModalProps) => {
  const metaData = useSelector((state: RootState) => state.modal.metaData) as
    | AuthLetterSuccessModalMetaData
    | undefined;

  const authorizations = useMemo<AuthorizationCardInfoProps[]>(
    () => metaData?.authorizations ?? [],
    [metaData],
  );

  return (
    <Modal
      dialogId={ModalId.AUTH_LETTER_SUCCESS_MODAL}
      onClose={onClose}
      onSave={onClose}
      title={"Authorization Details"}
      saveButtonText={""}
      cancelText={""}
      hideFooter
      maxHeightPercentage={80}
    >
      <div className="grid grid-cols-2 gap-4 pb-4">
        {authorizations.map((authorization, index) => (
          <AuthorizationCardInfo
            key={`${authorization.header.title}-${index}`}
            header={authorization.header}
            details={authorization.details}
            serviceCodes={authorization.serviceCodes}
          />
        ))}
      </div>
    </Modal>
  );
};

export default AuthLetterSuccessModal;
